export default `
    ... on Error {
        message
        code
    }
`;
